// Leading and trailing whitespace, including the zero-width spaces that ride along when a
// number is copied out of an rs.ge page. The server trims the same set before it validates,
// stores or forwards an application - see ApplicationNormalizer.
const SURROUNDING_SPACE = /^[\s​‌‍]+|[\s​‌‍]+$/g;

/** The value without its surrounding whitespace. Inner spaces are kept. */
export const trimValue = (value: string): string => value.replace(SURROUNDING_SPACE, '');

/**
 * Trims every string in a form's values, so a pasted "12345678 " is not reported as
 * "must be 8 digits" with nothing visibly wrong in the field. Non-string values pass through.
 */
export const trimAll = <T extends Record<string, unknown>>(values: T): T => {
  const trimmed = { ...values };
  Object.keys(trimmed).forEach(key => {
    const value = trimmed[key];
    if (typeof value === 'string')
      (trimmed as Record<string, unknown>)[key] = trimValue(value);
  });
  return trimmed;
};
